package com.partejar.app.feature.splash.presentation

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.sizeIn
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.partejar.app.core.session.SessionDestination
import com.partejar.app.core.ui.components.PartejarButton
import com.partejar.app.core.ui.theme.PartejarTheme
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.koinInject
import partejar_app.shared.generated.resources.Res
import partejar_app.shared.generated.resources.partejar_lockup_dark_transparent
import partejar_app.shared.generated.resources.partejar_lockup_light_transparent

@Composable
fun SplashScreen(
    isDarkTheme: Boolean,
    viewModel: SplashViewModel = koinInject(),
    onNavigateToAuth: () -> Unit,
    onDestinationResolved: (SessionDestination) -> Unit
) {
    val state by viewModel.state.collectAsState()

    // O LaunchedEffect escuta a decisão lógica do ViewModel e aciona o Roteador
    LaunchedEffect(state) {
        when (val currentState = state) {
            is SplashState.NavigateToAuth -> onNavigateToAuth()
            is SplashState.Navigate -> onDestinationResolved(currentState.destination)
            SplashState.Loading, SplashState.TemporarilyUnavailable -> Unit
        }
    }

    val spacing = PartejarTheme.spacing
    Surface(modifier = Modifier.fillMaxSize(), color = MaterialTheme.colorScheme.background) {
        Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Image(
                    painter = painterResource(
                        if (isDarkTheme) Res.drawable.partejar_lockup_dark_transparent else Res.drawable.partejar_lockup_light_transparent
                    ),
                    contentDescription = null,
                    contentScale = ContentScale.Fit,
                    modifier = Modifier.sizeIn(maxWidth = 280.dp, maxHeight = 210.dp)
                )
                Spacer(modifier = Modifier.height(spacing.space24))
                when (state) {
                    SplashState.TemporarilyUnavailable -> {
                        Text(
                            text = "Não foi possível conectar agora. Sua sessão continua salva.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                        Spacer(modifier = Modifier.height(spacing.space16))
                        PartejarButton(text = "Tentar novamente", onClick = viewModel::retry)
                    }
                    else -> CircularProgressIndicator(color = MaterialTheme.colorScheme.primary)
                }
            }
        }
    }
}
